import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { convertTimestampToDateTime } from '../../../../helper/helper';
import { UserModel } from '../../../../interfaces/user.interface';

interface UserRowProps {
    user: UserModel;
    handleEdit: (id: string) => void;
    setOpenDialog: (open: boolean) => void;
    setUserId: (id: string) => void;
    index: number;
}

const UserRow: React.FC<UserRowProps> = ({
    user,
    handleEdit,
    setOpenDialog,
    setUserId,
    index,
}) => {
    return (
        <tr key={index} className={`text-sm ${index % 2 === 0 ? 'bg-gray-100' : ''}`}>
            <td className="text-left py-2 px-4 border-b">
                {user.firstName} {user.lastName}
            </td>
            <td className="text-left py-2 px-4 border-b">{user.email}</td>
            <td className="text-left py-2 px-4 border-b capitalize">
                {user.role?.replace('-', ' ')}
            </td>
            <td className="text-left py-2 px-4 border-b whitespace-nowrap">
                {convertTimestampToDateTime(user?.timestamp)}
            </td>
            <td className="text-left py-2 px-4 border-b">
                <div className="flex gap-3">
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="cursor-pointer hover:text-storyblue"
                        title="Edit User"
                        onClick={() => handleEdit(user.id!)}
                    />
                    <FontAwesomeIcon
                        icon={faTrashCan}
                        className="cursor-pointer hover:text-red-600"
                        title="Delete User"
                        onClick={() => {
                            setOpenDialog(true);
                            setUserId(user.id!);
                        }}
                    />
                </div>
            </td>
        </tr>
    );
};

export default UserRow;
